import fetchStatistics from '@lyra/core/api/fetchStatistics'
import { AllInstrumentStatisticsSchema } from '@lyra/core/api/types/public.all_statistics'
import useSWR from 'swr'

import { EMPTY_INSTRUMENT_STATS, InstrumentType } from '../constants/instruments'
import { CurrencyId } from '../constants/tokens'

const fetcher = async (
  marketId: CurrencyId,
  instrumentType: InstrumentType
): Promise<AllInstrumentStatisticsSchema> => {
  const instrument = instrumentType
  const formattedInstrumentType =
    instrumentType === InstrumentType.Spot ? 'SPOT' : instrument.toUpperCase()

  const statsResponse = await fetchStatistics({
    currency: marketId,
    instrument_name: formattedInstrumentType,
  })

  const instrumentStatsData = statsResponse.result

  const instrumentStats: AllInstrumentStatisticsSchema = instrumentStatsData
    ? {
        currency: marketId,
        instrument_type: instrument,
        ...instrumentStatsData,
      }
    : EMPTY_INSTRUMENT_STATS

  return instrumentStats
}

export default function useMarketStats(currencyId: CurrencyId, instrumentType: InstrumentType) {
  return useSWR<AllInstrumentStatisticsSchema>(
    ['MarketStats', currencyId, instrumentType],
    () => fetcher(currencyId, instrumentType),
    {
      keepPreviousData: true,
      revalidateOnFocus: false,
    }
  )
}
